import React from 'react'
import { Wizard } from 'react-use-wizard'
import { Card, CardBody, CardHeader } from 'reactstrap'
import { WizardContext } from '../contexts/WizardContext'

const WizardHeader = ({children}) => {
  return (
    <CardHeader color='light' className='pt-4 pb-4 fs-3 text-secondary d-flex justify-content-center'>
        {children}
    </CardHeader>
  )
}

const WizardBody = ({children, bodyRef}) => {
  return (
    <CardBody innerRef={bodyRef}>
      {children}
    </CardBody>
  )
}

const WizardLayout = ({children, context}) => {
  return (
    <WizardContext.Provider value={context}>
      <Card color='light' className='mb-5'>
        {children}
      </Card>
    </WizardContext.Provider>
  )
}

Wizard.Header = WizardHeader
Wizard.Body = WizardBody

export default WizardLayout